(function() {
  function init() {
    var items = document.querySelectorAll('.noxor-reveal');
    if (!items.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.from(items).indexOf(entry.target);
        setTimeout(function() {
          entry.target.classList.add('visible');
        }, index * 100);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    items.forEach(function(item) { observer.observe(item); });

    // Play button vidéo locale
    var playBtn = document.querySelector('.noxor-gallery__play');
    var video = document.querySelector('.noxor-gallery__media video');
    if (playBtn && video) {
      playBtn.style.pointerEvents = 'all';
      playBtn.addEventListener('click', function() {
        video.play();
        playBtn.style.display = 'none';
      });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
